module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Roman.57ab8541.woff";